document.addEventListener('DOMContentLoaded', function () {

	const filters = document.querySelectorAll('.elementor-portfolio__filter');

	filters.forEach(filter => {

		// Fokusierbar machen
		filter.setAttribute('tabindex', '0');
		filter.setAttribute('role', 'button');

		// Tastatursteuerung
		filter.addEventListener('keydown', function(e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				filter.click();
			}
		});

	});

	function makeAccessible(el) {
		if (!el) {return;}

		if (!el.hasAttribute('tabindex')) {
			el.setAttribute('tabindex', '0');
		}

		if (!el.hasAttribute('role')) {
			el.setAttribute('role', 'button');
		}

		if (el.dataset.kbReady === '1') {return;}
		el.dataset.kbReady = '1';

		el.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				el.click();
			}
		});
	}

	function initLoadMoreButtons() {
		document.querySelectorAll(
			'.e-load-more-anchor, .elementor-button, .elementor-pagination .next, .elementor-pagination'
		).forEach(makeAccessible);
	}

	initLoadMoreButtons();

	const observer = new MutationObserver(function () {
		initLoadMoreButtons();
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	//---------------------  Active menü item
	const currentUrl = window.location.href.split('#')[0].replace(/\/$/, '');

	document.querySelectorAll('.elementor a[href]').forEach(function (link) {
		const linkUrl = link.href.split('#')[0].replace(/\/$/, '');

		if (linkUrl === currentUrl) {
			link.classList.add('is-current-menu-link');

			const megaParent = link.closest('.e-n-menu-item, .e-n-menu-dropdown-icon, .elementor-widget-n-menu');
			if (megaParent) {
				megaParent.classList.add('is-current-menu-parent');
			}
		}
	});

});
